import { UserRoleEnum } from '@acme/api';

export const getUserRoleName = (roleId?: UserRoleEnum): string => {
  switch (roleId) {
    case UserRoleEnum.Owner:
      return 'Владелец';
    case UserRoleEnum.Employee:
      return 'Сотрудник';
    default:
      return '';
  }
};

